/**
 * @type {function}
 * @param keyname
 * @desc This utility exposes various functions to match the keyname with the key and returns true or false as result.
 * @example
 * import { isEnterKey } from 'utils/keyChecker';
 */

const KEY_CODES = {
    ARROW_UP: 'ArrowUp',
    ARROW_UP_IE: 'Up',
    ARROW_DOWN: 'ArrowDown',
    ARROW_DOWN_IE: 'Down',
    ENTER: 'Enter',
    TAB: 'Tab',
    ESCAPE: 'Escape',
    ESCAPE_IE: 'Esc'
};


export const isEnterKey = ( keyname ) => {
    return ( keyname === KEY_CODES.ENTER );
};

export const isEscapeKey = ( keyname ) => {
    return ( keyname === KEY_CODES.ESCAPE || keyname === KEY_CODES.ESCAPE_IE );
};

export const isTabKey = ( keyname ) => {
    return ( keyname === KEY_CODES.TAB );
};

export const isArrowDownKey = ( keyname ) => {
    return ( keyname === KEY_CODES.ARROW_DOWN || keyname === KEY_CODES.ARROW_DOWN_IE );
};

export const isArrowUpKey = ( keyname ) => {
    return ( keyname === KEY_CODES.ARROW_UP || keyname === KEY_CODES.ARROW_UP_IE );
};


